import { createFileRoute } from '@tanstack/react-router';

import { SupplierRegisterPage } from '@/features/supplier/register-page';

export const Route = createFileRoute('/_app/supplier/register')({
  component: SupplierRegisterPage,
});
